<div class="main-content">
    <div class="container-fluid">
        <div class="card">
            <div class="card-header-{{ color }}">
                <h4 class="card-title">
                <i class="material-icons">qr_code</i>
                Barcode Generator
                </h4>
            </div>
            <div class="card-body">
                <div class="content-grid">
                <div class="left-pane">
                <div class="section-title">Generate</div>
                <form [formGroup]="form" (ngSubmit)="generatePreview()" class="form-grid">
                <div class="form-simple">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Symbology</mat-label>
                    <mat-select formControlName="symbology">
                      <mat-option value="code128">Code128</mat-option>
                      <mat-option value="code39">Code39</mat-option>
                      <mat-option value="itf">ITF</mat-option>
                      <mat-option value="ean13">EAN-13</mat-option>
                      <mat-option value="ean8">EAN-8</mat-option>
                      <mat-option value="upca">UPC-A</mat-option>
                      <mat-option value="upce">UPC-E</mat-option>
                      <mat-option value="qr">QR</mat-option>
                      <mat-option value="datamatrix">DataMatrix</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <div class="form-row">
                    <mat-form-field appearance="outline" class="form-field-half">
                      <mat-label>Width</mat-label>
                      <input matInput type="number" formControlName="width">
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="form-field-half">
                      <mat-label>Height</mat-label>
                      <input matInput type="number" formControlName="height">
                    </mat-form-field>
                  </div>

                  <div class="form-toggle">
                    <mat-slide-toggle formControlName="displayValue">Show text</mat-slide-toggle>
                  </div>

                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Barcode Values</mat-label>
                    <textarea matInput rows="4" formControlName="batchList" placeholder="Enter one or more values (one per line)&#10;Example:&#10;ABC123&#10;XYZ789"></textarea>
                  </mat-form-field>
                </div>
                <div class="toolbar">
                    <div class="left">
                    <button mat-raised-button color="primary" [disabled]="loading" type="submit">
                        <mat-icon>play_arrow</mat-icon>
                        <span>Generate</span>
                    </button>
                    <button mat-stroked-button type="button" (click)="selectAll(true)">
                        <mat-icon>done_all</mat-icon>
                        <span>All</span>
                    </button>
                    <button mat-stroked-button type="button" (click)="selectAll(false)">
                        <mat-icon>remove_done</mat-icon>
                        <span>None</span>
                    </button>
                    </div>
                    <div class="right" *ngIf="previews.length">
                    <mat-form-field appearance="outline" class="tpl-field">
                        <mat-label>Label Template</mat-label>
                        <mat-select formControlName="templateId">
                        <mat-option *ngFor="let t of templates" [value]="t.id">{{ t.name }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <button mat-raised-button color="primary" type="button" (click)="exportPdf()">
                        <mat-icon>picture_as_pdf</mat-icon>
                        <span>PDF</span>
                    </button>
                    <button mat-stroked-button type="button" (click)="exportPng()">
                        <mat-icon>image</mat-icon>
                        <span>PNG</span>
                    </button>
                    <button mat-stroked-button type="button" (click)="exportSvg()">
                        <mat-icon>integration_instructions</mat-icon>
                        <span>SVG</span>
                    </button>
                    </div>
                </div>
                </form>
                </div>

                <div class="right-pane" *ngIf="previews.length">
                <div class="section-title preview-header">
                  <div class="count">{{ previews.length }} Results</div>
                  <div class="quick-select">
                    <button mat-button color="primary" (click)="selectAll(true)">All</button>
                    <button mat-button (click)="selectAll(false)">None</button>
                  </div>
                </div>
                <div class="preview-grid">
                <div class="preview-item" *ngFor="let p of previews">
                    <mat-checkbox class="select-box" [(ngModel)]="p.selected"></mat-checkbox>
                    <div class="thumb" *ngIf="p.dataUrl">
                    <img [src]="p.dataUrl" alt="barcode">
                    </div>
                    <div class="meta">
                    <div class="val">{{ p.value }}</div>
                    <div class="sym">{{ p.symbology }}</div>
                </div>
                </div>
                </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</div>
            


